import React, { Fragment } from 'react';
import styled from 'styled-components';
import { useTranslation, Trans } from 'react-i18next';
// import { H1, H2, Button, Switch, Label, CellText, Spinner } from '@increasecard/typed-components';
import { H1, H2, Button, CellText, Spinner } from '@increasecard/typed-components';
import { SelectInput, Checkbox, SearchInput } from '@card/commonlib';
import { useShallowEqualSelector } from '../../utils/reduxUtils';
import { Redirect } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { History } from 'history';
import { ShopFormatedType, currentManagerUserInitial } from './reducers/managerUsersReducers';
import { ManagerUsersActions } from './actions/managerUsersActions';
import { useEventTracker } from '@increasecard/increase-core';

const SelectOptions = [
  {
    label: 'Seleccionar Rol',
    value: 'none',
    disabled: true
  },
  {
    label: 'Administrador',
    value: 'true'
  },
  {
    label: 'Colaborador',
    value: 'false'
  }
];

const managerUsersListDirection = '../../../settings/users';

const GridBase = styled.div`
  display: grid;
  grid-template-columns: repeat(10, 1fr);
  grid-column-gap: 1rem;
  align-items: center;
`;

const CheckboxesGrid = styled(GridBase)`
  grid-template-areas: 'ft   ft   ft   ft   ft   ft   ft   ft   .   .';
  .content {
    display: grid;
    grid-area: ft;
    grid-template-columns: repeat(8, 1fr);
    grid-column-gap: 1rem;
    grid-row-gap: 1.25rem;
  }
`;

// const SwitchContainer = styled.div`
//   grid-column: span 4;
//   display: flex;
// `;

// const CustomLabel = styled(Label)`
//   grid-column: span 6;
//   margin: 4px 0 0 8px;
//   font-size: 13px;
//   letter-spacing: -0.003em;
//   text-transform: inherit;
//   font-weight: normal;
// `;

const SelectInputGroup = styled(SelectInput)`
  margin: 0;
  grid-column: span 2;
  font-size: 13px;
`;

const SelectInputGroupParagraph = styled.div`
  grid-column: span 6;
  margin-top: 15px;
`;

const Section = styled.div`
  margin-top: 40px;
`;

const SearchInputCustom = styled(SearchInput)`
  grid-column: span 2;
  font-size: 13px;
`;

const SectionTitle = styled(H2)`
  margin-bottom: 1em;
`;

const MainTitle = styled(H1)`
  margin-bottom: 0;
`;

const CancelButton = styled.span`
  margin-left: 1rem;
`;

const LoadingSpinner = styled(Spinner)`
  margin-top: 0.3em;
`;

interface EditUserProps {
  history: History;
}

export function EditUserScreen({ history }: EditUserProps) {
  const { t } = useTranslation();
  const tracker = useEventTracker();
  const dispatch = useDispatch();
  const {
    currentManagerUser,
    currentManagerUserShopsFiltered,
    currentManagerUserShops,
    searchShopsWord,
    // allShopsAssigned,
    savingManagerUser,
    returnToUsersList
  } = useShallowEqualSelector(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (state) => state.managerUsers
  );

  /*
  Writing just ".." in property "To", the navigation doesn't work correctly.
   Here, I could do the same, setting the variable "CurrentManagerUser" with the value "currentManagerUserInitial" on
   the action "SAVE_MANAGER_USER_SUCCESS" instead using variable returnToUsersList,
   but I think that this way is more clarifying.
   */
  if (currentManagerUser === currentManagerUserInitial || returnToUsersList)
    return <Redirect push to={managerUsersListDirection} />;

  function changeShopAssignation(shop: ShopFormatedType): void {
    dispatch(ManagerUsersActions.saveShop({ ...shop, isAssigned: !shop.isAssigned }));
  }

  function changeUserType(): void {
    dispatch(ManagerUsersActions.changeUserType());
  }

  const filterShops = (e: React.ChangeEvent<HTMLInputElement>) =>
    dispatch(ManagerUsersActions.filterShops(e.target.value));

  // function selectAll(): void {
  //   dispatch(ManagerUsersActions.selectAll());
  // }

  function saveUser(): void {
    // eslint-disable-next-line @typescript-eslint/camelcase
    tracker.track('Edit User', { user_id: currentManagerUser.id });
    dispatch(ManagerUsersActions.saveUser(currentManagerUser, currentManagerUserShops));
  }

  return (
    <Fragment>
      <MainTitle>{t(`abm:Users:User:title_edit`)}</MainTitle>
      <Section>
        <SectionTitle>{t(`abm:Users:User:role`)}</SectionTitle>
        <GridBase>
          <SelectInputGroup
            label={t(`abm:Users:User:user_type_label`)}
            name="userType"
            onBlur={() => null}
            onChange={() => {
              changeUserType();
            }}
            options={SelectOptions}
            value={currentManagerUser.account_administrator.toString()}
          />
          <SelectInputGroupParagraph>
            <Trans
              i18nKey={`abm:Users:User:${
                currentManagerUser.account_administrator
                  ? 'admin_role_disclaimer'
                  : 'user_role_disclaimer'
              }`}
            >
              <CellText inline />
              <CellText inline weight="bold" />
              <CellText inline />
            </Trans>
          </SelectInputGroupParagraph>
        </GridBase>
      </Section>
      <Section>
        <SectionTitle>{t(`abm:Users:User:asigned_shops`)}</SectionTitle>
        <GridBase>
          <SearchInputCustom
            id="search"
            name="search"
            onChange={filterShops}
            placeholder={t(`abm:Users:User:searchPlaceholder`)}
            type="search"
            value={searchShopsWord}
          />
          {/* TO DO: Hay que implementar un checkbox con un estado intermedio
          el cual refleje que el listado filtrado está seleccionado todo, pero
          que no representa a todos los shops */}
          {/* <SwitchContainer>
            <Switch name="selectAll" onChange={selectAll} value={allShopsAssigned} />
            <CustomLabel>{t(`abm:Users:User:shops_select_all`)} </CustomLabel>
          </SwitchContainer> */}
        </GridBase>
      </Section>
      <Section>
        <CheckboxesGrid>
          <div className="content">
            {currentManagerUserShopsFiltered.map((shop) => {
              return (
                <Checkbox
                  checked={shop.isAssigned}
                  key={shop.shop.id}
                  label={shop.shop.name}
                  name={shop.shop.id}
                  onClick={() => {
                    changeShopAssignation(shop);
                  }}
                  //I don´t know why the component Checkbox doesn`t accept styledComponent
                  style={{
                    gridColumn: 'span 2',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis'
                  }}
                />
              );
            })}
          </div>
        </CheckboxesGrid>
      </Section>
      <Section>
        <Button disabled={savingManagerUser} onClick={saveUser}>
          {savingManagerUser ? <LoadingSpinner size={24} /> : t(`abm:Users:User:save_changes`)}
        </Button>
        <CancelButton>
          <Button buttonType="invisible" onClick={() => history.push(managerUsersListDirection)}>
            {t(`abm:Users:User:cancel`)}
          </Button>
        </CancelButton>
      </Section>
    </Fragment>
  );
}
